import './OnboardingScreen.scss'

import cls from 'classnames'
import type { ReactNode } from 'react'

type OnboardingScreenProps = {
	readonly children: ReactNode
	readonly className?: string
}

export const OnboardingScreen = ({ children, className }: OnboardingScreenProps) => (
	<div className={cls('onboarding-screen', className)}>{children}</div>
)

type OnboardingContentProps = {
	readonly children: ReactNode
	readonly className?: string
}

const OnboardingContent = ({ children, className }: OnboardingContentProps) => (
	<section className={cls('max-w-md w-full flex flex-col items-center', className)}>
		{children}
	</section>
)

type OnboardingHeaderProps = {
	readonly children: ReactNode
	readonly className?: string
}

const OnboardingHeader = ({ children, className }: OnboardingHeaderProps) => (
	<h3
		className={cls(
			'text-lg sm:text-xl font-bold text-center text-balance max-w-md mb-4 sm:mb-6 md:mb-8',
			className,
		)}
	>
		{children}
	</h3>
)

OnboardingScreen.Content = OnboardingContent
OnboardingScreen.Header = OnboardingHeader
